var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailNewsBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 868,
    height: 144,
    viewBox: "0 0 868 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3585_28587)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 868,
    height: 144,
    rx: 12,
    fill: "#182BCF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3585_28587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 670,
    y: -11,
    width: 170,
    height: 205
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M840 -11H670V193.358H840V-11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3585_28587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.394 61.4782H719.284C725.683 61.4782 730.881 66.6916 730.881 73.1092V98.1564C730.881 104.574 725.683 109.787 719.284 109.787H718.394C711.995 109.787 706.797 104.574 706.797 98.1564V73.0951C706.797 66.6774 711.995 61.464 718.394 61.464V61.4782Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.284 158.111H718.394C711.981 158.111 706.797 152.898 706.797 146.48V121.419C706.797 114.987 711.995 109.787 718.394 109.787H719.284C725.697 109.787 730.881 115.001 730.881 121.419V146.48C730.881 152.898 725.697 158.111 719.284 158.111Z",
    fill: "#44BB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.417 109.802H754.527C748.114 109.802 742.93 104.588 742.93 98.1706V50.1163C742.93 43.6987 748.128 38.4852 754.527 38.4852H755.417C761.83 38.4852 767.014 43.6987 767.014 50.1163V98.1706C767.014 104.588 761.83 109.802 755.417 109.802Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.527 109.802H755.417C761.815 109.802 767.014 115.015 767.014 121.433V169.487C767.014 175.905 761.815 181.118 755.417 181.118H754.527C748.128 181.118 742.93 175.905 742.93 169.487V121.433C742.93 115.015 748.128 109.802 754.527 109.802Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.682 109.802H826.792C820.393 109.802 815.195 104.588 815.195 98.1706V0.631073C815.195 -5.80073 820.393 -11 826.792 -11H827.682C834.081 -11 839.279 -5.80073 839.279 0.631073V98.1706C839.279 104.588 834.081 109.802 827.682 109.802Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.792 109.802H827.682C834.081 109.802 839.279 115.015 839.279 121.433V218.972C839.279 225.39 834.081 230.603 827.682 230.603H826.792C820.393 230.603 815.195 225.39 815.195 218.972V121.433C815.195 115.015 820.393 109.802 826.792 109.802Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.66 13.1547H791.549C797.948 13.1547 803.146 18.3681 803.146 24.7857V98.1564C803.146 104.574 797.948 109.787 791.549 109.787H790.66C784.261 109.787 779.062 104.574 779.062 98.1564V24.7857C779.062 18.3681 784.261 13.1547 790.66 13.1547Z",
    stroke: "#9B87BF",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.549 206.434H790.66C784.247 206.434 779.062 201.221 779.062 194.803V121.433C779.062 115.015 784.261 109.802 790.66 109.802H791.549C797.962 109.802 803.146 115.015 803.146 121.433V194.803C803.146 201.221 797.948 206.434 791.549 206.434Z",
    fill: "#5061F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.805 109.802C694.805 116.474 689.409 121.886 682.756 121.886C676.103 121.886 670.707 116.474 670.707 109.802C670.707 103.129 676.103 97.7172 682.756 97.7172C689.409 97.7172 694.805 103.129 694.805 109.802Z",
    fill: "#5061F1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3585_28587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 868,
    height: 144,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailNewsBg);
export default __webpack_public_path__ + "static/media/detail-news-bg.5ba676d93197417db4b781ce971720d5.svg";
export { ForwardRef as ReactComponent };